import { SDK_CONFIG_KEY } from './constants';
import { SESSION_MANAGER_KEY, SESSION_RECORDER_KEY, } from './session/session.consts';
import { SNAPSHOT_MANAGER_KEY } from './snapshot/snapshot.consts';
export function getSnapshotManager() {
    return window[SNAPSHOT_MANAGER_KEY];
}
export function getSessionManager() {
    return window[SESSION_MANAGER_KEY];
}
export function getSessionRecorder() {
    return window[SESSION_RECORDER_KEY];
}
export function getSdkConfig() {
    return window[SDK_CONFIG_KEY];
}
export function clearMemoryFrom(keys) {
    keys.forEach((key) => {
        delete window[key];
    });
}
//# sourceMappingURL=helpers.js.map